import React from 'react';
import styled from 'styled-components';
import { Image, Tag } from 'antd';
import { theme } from 'utils/style/theme';

/**
 * * 등록된 이미지 보여주기 태그
 * ImageNameTag.js 와 같은 형식 비교 후 더 나은걸로 채택하자 (TODO: 지연, 22.05.11)
 */

interface IProps {
  src: string | undefined;
  text?: string;
  onClose?: () => void;
}
const CurrentImgTag: React.FC<IProps> = ({
  src,
  text,
  onClose,
}): JSX.Element => {
  return (
    <StyledTag closable={onClose ? true : false} onClose={onClose}>
      <Image src={src} alt={text} />
      <p className='p_img_name'>{text}</p>
    </StyledTag>
  );
};

export default CurrentImgTag;

const StyledTag = styled(Tag)`
  position: relative;
  padding: 0.6rem 1.5rem;
  width: 100%;
  text-align: center;
  background-color: ${theme.colors.gray_4};
  border: none;
  border-radius: 14px;
  font-size: 14px;
  .ant-image {
    text-align: center;
    margin-top: 0.5rem;
    /* width: 90%; */
    height: 50%;
    > img {
      object-fit: contain;
    }
  }
  .ant-image-img {
    /* width: 90%; */
    height: 8rem;
  }
  .anticon[tabindex] {
    position: absolute;
    top: 0.6rem;
    right: 1.5rem;
  }
  .p_img_name {
    margin-top: 0.3rem;
    font-size: 0.8rem;
    color: ${theme.colors.gray_2};
    font-weight: 600;
  }
`;
